<div
    class="cmps-cdk-border-radius-4px cmps-cdk-bg-color-white cmps-uik-box-shadow-200 cmps-cdk-p-1 cmps-cdk-d-flex cmps-cdk-flex-column"
>
    <cmps-radio-group
        [ngModel]="_state.viewParams.dataSource"
        (ngModelChange)="_onChange($event)"
    >
        <div class="cmps-cdk-d-flex cmps-cdk-cg-0dot5">
            <cmps-radio [value]="_DataSource.Cache">Cached</cmps-radio>
            <cmps-radio [value]="_DataSource.Raw">Custom</cmps-radio>
        </div>
    </cmps-radio-group>
</div>
